<template>
  <div class="data-section-content">
    <h3>Selected compared to Africa</h3>
    <common-charts/>
    <v-tabs background-color="transparent" color="basil" active-class="active">
      <v-tab>Companies</v-tab>
      <v-tab>Development projects</v-tab>
      <v-tab-item>
        <!-- <companies-charts /> -->
        <data-table/>
      </v-tab-item>
      <v-tab-item eager>
        <projects-charts/>
        <projects-table/>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DataTable from '@/components/data-table'
import ProjectsTable from '@/components/projects-table'
import ProjectsCharts from '@/components/charts/projects-charts'
import CommonCharts from '@/components/charts/common-charts'

export default {
  name: 'data-section',
  components: {
    DataTable,
    ProjectsTable,
    ProjectsCharts,
    CommonCharts,
  },
}
</script>

<style lang="scss" scoped>
.data-section-content {
  h3 {
    font-size: 24px;
    font-weight: 300;
    margin-top: 20px;
    margin-left: 30px;
    margin-bottom: 20px;
  }
}
.active {
  color: #155ead !important;
}

.data-section-content ::v-deep .v-item-group {
  border-bottom: 1px solid #e5e5e5;
}
.data-section-content ::v-deep .v-slide-group__wrapper {
  padding: 0 15px;
  border-bottom: 1px solid #e5e5e5;
}
.data-section-content ::v-deep .v-tabs-slider-wrapper {
  height: 1px !important;
}
.data-section-content ::v-deep .v-tab {
  font-size: 12px;
}
</style>
